import { SELL_DOCUMENT_TYPE_DESCRIPTIONS } from './descriptions';

const getSellDocumentTypeDescription = (
  type: string | number,
  fallbackValue = '',
): string => {
  const description = SELL_DOCUMENT_TYPE_DESCRIPTIONS[Number(type)];

  return description ?? fallbackValue;
};

export { getSellDocumentTypeDescription };
